<template>
  <div class="card-container">
    <div class="item-left">
      <div
        class="user-img"
        v-bind:style="{ background: getInformation('image') }"
        @click="routeToProfile()"
      >
        <img
          style="margin-left: -5px; margin-top: -8px"
          class="active-icon"
          :src="activeIcon"
          alt
        />
      </div>
      <!-- <div
        v-if="!(type === 'nfp' || type === 'hospital')"
        class="rating"
        v-bind:style="{NavigationDuplicated: Avoided redundant navigation to current location:
          background: info.overall_rating ? getPrimaryColor() : '#A0AEBE',
        }"
      >
        <font-awesome-icon
          :style="{ color: '#fff', transform: 'scale(0.8)' }"
          :icon="['fas', 'star']"
        />
        {{
          info.overall_rating
            ? parseFloat(info.overall_rating / 10).toFixed(1)
            : `N/A`
        }}
      </div>
      <span v-if="!(type === 'nfp' || type === 'hospital')" class="review"
        >{{ info.rating_count_overall }} Reviews</span
      > -->
    </div>
    <div class="divider"></div>
    <div class="item-right row m-0">
      <div
        :class="
          hideBtn
            ? 'col-md-7 col-sm-12 p-0'
            : 'col-md-5 col-sm-12 p-0 item-right--name '
        "
      >
        <h3
          v-if="info.promoted"
          class="promoted-label"
          v-bind:style="{
            background: getAlphaPrimaryColor(),
            color: getSecondaryColor()
          }"
        >
          Promoted
        </h3>
        <h2 class="provider-name" @click="routeToProfile()">
          {{ getInformation("name") }}
        </h2>
        <h3 class="provider-title">
          {{ getInformation("title") }}
        </h3>
        <span v-if="info.clinic" class="provider-desc"
          >Part of Christie Clinic LLC</span
        >
        <div class="tags">
          <span
            v-if="info.premium"
            class="crown"
            v-bind:style="{
              color: getSecondaryColor(),
              background: getAlphaPrimaryColor()
            }"
          >
            <font-awesome-icon :icon="['fas', 'crown']" />
          </span>
          <span
            v-if="getInformation('area')"
            v-bind:style="{
              color: getSecondaryColor(),
              background: getAlphaPrimaryColor()
            }"
            class="tag"
            >{{ getInformation("area") }}</span
          >
          <span
            v-bind:style="{
              color: getSecondaryColor(),
              background: getAlphaPrimaryColor()
            }"
            v-if="getInformation('plusarea')"
            class="tag"
            >+{{ getInformation("plusarea") }}</span
          >
        </div>
      </div>
      <div
        :class="
          hideBtn
            ? 'col-md-5 col-sm-12 p-0 pl-1 pr-1'
            : 'col-md-4 col-sm-12 p-0 pl-1 pr-1'
        "
      >
        <p v-if="info.phone_number" class="m-0 mb-1 row">
          <font-awesome-icon
            style="margin-top: 4px; margin-left: -2px"
            :icon="['fal', 'phone-alt']"
            :style="{ color: '#A0AEBE' }"
          />
          <span class="contact-number ml-1" style="flex: 1">{{
            info.phone_number
          }}</span>
        </p>
        <span v-if="info.address">
          <p class="m-0 mb-1 row">
            <font-awesome-icon
              style="margin-top: 2px"
              :icon="['fal', 'map-marker-alt']"
              :style="{ color: '#A0AEBE' }"
              v-if="info.address"
            />
            <span
              v-if="typeof info.address !== 'object'"
              class="address ml-1"
              style="flex: 1"
            >
              <span :style="{ color: '#3333338A' }" v-if="info.city">
                {{ info.city }}, {{ info.state }}
                <br />
                {{
                  info.address
                    .split(" ")
                    .filter(sttr => sttr !== "None,")
                    .join(" ")
                }}
              </span>
              <span v-else>
                {{
                  info.address
                    .split(" ")
                    .filter(sttr => sttr !== "None,")
                    .join(" ")
                }}
              </span>
            </span>
            <span
              v-if="typeof info.address === 'object'"
              class="address ml-1"
              style="flex: 1"
            >
              <span v-if="info.address.city" :style="{ color: '#3333338A' }">
                {{ info.address.city }}, {{ info.address.state }}</span
              >
              <br />
              {{ info.address.street }}
            </span>
          </p>
        </span>
        <span v-if="typeof info.location === 'array'">
          <p class="m-0 mb-1 row">
            <font-awesome-icon
              v-if="info.location"
              :icon="['fal', 'map-marker-alt']"
              :style="{ color: '#A0AEBE' }"
            />
            <span class="address ml-1" style="flex: 1">
              {{ info.location[0].city }}, {{ info.location[0].state }}
              <br />
              {{ info.location[0].address }}
            </span>
          </p>
        </span>
      </div>
      <div v-if="!hideBtn" class="col-md-3 col-sm-12 p-0">
        <div class="btn-container1">
          <div
            :disable="addCircleButtonText === 'In your circle'"
            class="btn-primary1"
            v-bind:style="
              addCircleButtonText === 'In your circle'
                ? { background: getSecondaryColor(), 'pointer-events': 'none' }
                : { background: getPrimaryColor(), cursor: 'pointer' }
            "
            @click="addVirtualDocToCircle(info)"
          >
            <div
              v-if="
                loadingbtn === info.id
                  ? info.id
                  : this.affiliatedId
                  ? this.affiliatedId
                  : this.$route.params.id
              "
              class="spinner-border spinner-border2 position-absolute spinner-class"
            ></div>
            {{ addCircleButtonText }}
            <i
              class="fa fa-check font-white"
              aria-hidden="true"
              v-if="addCircleButtonText === 'In your circle'"
            ></i>
          </div>
          <!-- <div
            class="btn-secondary1"
            v-bind:style="{
              border: '1px solid' + getPrimaryColor(),
              color: getPrimaryColor(),
              cursor: 'pointer',
            }"
            @click="openReviewModal(info)"
          >
            REVIEW
          </div> -->
          <div
            v-if="type !== 'nfp'"
            :disabled="info.recommend ? true : false"
            class="btn-secondary1"
            v-bind:style="
              info.recommend
                ? {
                    background: getSecondaryColor(),
                    cursor: 'pointer',
                    color: 'white',
                    border: '1px solid' + getPrimaryColor()
                  }
                : {
                    border: '1px solid' + getPrimaryColor(),
                    color: getPrimaryColor(),
                    cursor: 'pointer'
                  }
            "
            @click="!info.recommend && openReviewModal(info)"
          >
            {{ info.recommend ? "Reviewed" : "Review" }}
          </div>
        </div>
      </div>
    </div>
    <RecommendOthersModal ref="recommendOthersModal" :fetchUser="fetchDoc" />
    <RecommendDoctorModal ref="recommendDoctorModal" :fetchUser="fetchDoc" />

    <div
      v-if="loading === (this.info.id ? this.info.id : this.affiliatedId)"
      class="spinnerContainer2"
    >
      <a-spin size="large" />
    </div>
  </div>
</template>

<script>
const svg1 = require("../../../assets/icon-check-badge.svg");
const svg2 = require("../../../assets/icon-uncheck-badge.svg");
import RecommendDoctorModal from "../../Modals/RecommendDoctor";
import RecommendOthersModal from "../../Modals/RecommendOthers";
import UserRepository from "../../../repositories/userRepository.js";
export default {
  name: "ProviderCard",
  components: {
    RecommendDoctorModal,
    RecommendOthersModal
  },
  data() {
    return {
      activeIcon: null,
      loadingbtn: null,
      loading: false,
      addCircleButtonText: this.info.on_circle
        ? "In your circle"
        : "Add To Circle",
      showReview: this.type === "nfp" ? false : true,
      defaultHospitalImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Hospital.svg",
      defaultClinicImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/Clinic.svg",
      defaultNfpImage:
        "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/nfp-icon.svg"
    };
  },
  methods: {
    openReviewModal(info) {
      //this.$refs.recommendDoctorModal.show({ ...info, role: this.type === "hcps" ? "hcp" : this.type });

      console.log("type ->", this.type);
      console.log("info ->", info);

      switch (this.type) {
        case "hcps":
        case "hcp":
          this.$refs.recommendDoctorModal.show({
            ...info,
            role: "hcp",
            page: this.page,
            inPersonReview: info.in_person_visit,
            onlineReview: info.online_tele_medicine,
            myCirclesReview: info.my_circle
          });
          break;
        case "clinic":
          this.$refs.recommendOthersModal.show({
            ...info,
            role: "clinic",
            page: this.page
          });
          break;
        case "hospital":
          this.$refs.recommendOthersModal.show({
            ...info,
            role: "hospital",
            page: this.page
          });
          break;
        case "providers":
          this.$refs.recommendDoctorModal.show({
            ...info,
            role: "doctor",
            page: this.page,
            inPersonReview: info.in_person_visit,
            onlineReview: info.online_tele_medicine,
            myCirclesReview: info.my_circle
          });
          break;
        case "doctor":
          this.$refs.recommendDoctorModal.show({
            ...info,
            role: "doctor",
            id: this.affiliatedId,
            page: this.page,
            inPersonReview: info.in_person_visit,
            onlineReview: info.online_tele_medicine,
            myCirclesReview: info.my_circle
          });
          break;
        default: {
          this.$refs.recommendDoctorModal.show({
            ...info,
            role: this.type,
            page: this.page,
            inPersonReview: info.in_person_visit,
            onlineReview: info.online_tele_medicine,
            myCirclesReview: info.my_circle
          });
        }
      }
    },
    addVirtualDocToCircle(info) {
      console.log("info ->", info);
      const id = info.id
        ? info.id
        : this.affiliatedId
        ? this.affiliatedId
        : this.$route.params.id;

      this.loadingbtn = id;
      console.log(this.loadingbtn);
      const idParam =
        this.type === "doctor" ||
        this.type === "hospital_administrator" ||
        this.type === "clinic_administrator" ||
        this.type === "nfp_administrator"
          ? info
          : id;
      UserRepository.addUserByTypeToCircle(
        idParam,
        this.currentCircle.id,
        this.type
      )
        .then(res => {
          this.loadingbtn = false;
          this.$notification.success({
            message: "Success",
            description: res.data.message
          });
          this.addCircleButtonText = "In your circle";
        })
        .catch(err => {
          this.$notification.info({
            message: "Information",
            description: err.response.data.message
          });
          if (err.response.data.message == "already added") {
            this.addCircleButtonText = "In your circle";
          }
          //this.addCircleButtonText = "ADD TO CIRCLE";
        });
      //this.$emit("addVirtualDocToCircle", info);
    },
    routeToProfile() {
      this.loading = this.info.id ? this.info.id : this.affiliatedId;
      let data = { ...this.info, role: this.type };

      switch (this.type) {
        case "physician":
          this.viewEntityProfile({
            ...this.info,
            role: "doctor",
            id: this.info.id ? this.info.id : this.affiliatedId
          });

          break;
        case "doctor":
          console.log("doctor");
          console.log(this.id);
          this.viewEntityProfile({
            ...this.info,
            role: "doctor",
            // id: this.info.id ? this.info.id : this.affiliatedId
            id: this.id
          });

          break;
        case "providers":
          data.ext_ref_id
            ? this.viewEntityProfile({ ...this.info, role: "doctor" })
            : this.viewProfile({
                ...this.info,
                role: "doctor",
                id: this.info.id
              });
          break;
        case "other":
          this.viewEntityProfile({ ...this.info, role: "hcp" });
          break;
        case "hcps":
          this.viewEntityProfile({ ...this.info, role: "hcp" });
          break;
        case "hospital":
          this.info.id
            ? this.viewEntityProfile({ ...this.info, role: "hospital" })
            : this.viewProfile({
                ...this.info,
                role: "hospital_administrator",
                id: this.info.id
              });
          break;
        case "clinic":
          this.viewEntityProfile(data);
          break;
        case "nfp":
          this.viewEntityProfile(data);
          break;
      }
    },
    getInformation(value) {
      switch (this.type) {
        case "physician": {
          switch (value) {
            case "name":
              return `${this.info.first_name} ${this.info.last_name}, ${this
                .info.title || ""}`;
            case "title":
              return `${this.info.speciality ||
                this.info.physician_speciality ||
                ""}`;
            case "area":
              return this.info.areas_of_practice &&
                this.info.areas_of_practice.length
                ? this.info.areas_of_practice[0]
                : null;
            case "plusarea":
              return this.info.areas_of_practice &&
                this.info.areas_of_practice.length
                ? this.info.areas_of_practice.length - 1
                : null;
            case "image":
              let default_image =
                "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/";
              default_image +=
                this.info.gender === "m"
                  ? "MALE DOCTOR2x.png"
                  : "WOMAN DOCTOR2x.png";
              return this.info.picture
                ? `url('${this.info.picture}')`
                : `url('${default_image}')`;
            default:
              return;
          }
        }
        case "hospital": {
          switch (value) {
            case "name":
              return this.info.hospital_name
                ? this.info.hospital_name
                : this.info.display_name;
            case "title":
              return this.info.hospital_type_desc || "";
            case "area":
              return this.info.specialist_tag
                ? this.info.specialist_tag[0]
                : null;
            case "plusarea":
              return this.info.specialist_tag
                ? this.info.specialist_tag - 1
                : null;
            case "image":
              if (this.info.image) {
                return `url('${this.info.image}')`;
              }
              if (this.info.picture) {
                return `url('${this.info.picture}')`;
              }
              if (this.info.url) {
                return `url('${this.info.url}')`;
              }
            default:
              return;
          }
        }
        case "clinic": {
          switch (value) {
            case "name":
              return this.info.clinic_name
                ? this.info.clinic_name
                : this.info.display_name;
            case "title":
              return this.info.clinic_type_desc || "";
            case "area":
              return this.info.specialist_tag
                ? this.info.specialist_tag[0]
                : null;
            case "plusarea":
              return this.info.specialist_tag
                ? this.info.specialist_tag - 1
                : null;
            case "image":
              return this.info.image
                ? `url('${this.info.image}')`
                : `url('${this.defaultClinicImage}')`;

            default:
              return;
          }
        }
        case "nfp": {
          switch (value) {
            case "name":
              return this.info.nfp_name;
            case "title":
              return this.info.nfp_name ? this.info.nfp_name : null;
            case "area":
              return this.info.nfp_type ? this.info.nfp_type : null;
            case "plusarea":
              return null;
            case "image":
              return this.info.image
                ? `url('${this.info.image}')`
                : `url('${this.defaultNfpImage}')`;
            default:
              return "";
          }
        }
        default:
          switch (value) {
            case "name":
              return `${this.info.first_name} ${this.info.last_name}${
                this.info.title !== null
                  ? `, ${this.info.title || ""}`
                  : "" || ""
              }`;
            case "title":
              return `${this.info.speciality ||
                this.info.physician_speciality ||
                ""}`;
            case "area":
              return this.info.areas_of_practice &&
                this.info.areas_of_practice.length
                ? this.info.areas_of_practice[0]
                : null;
            case "plusarea":
              return this.info.areas_of_practice &&
                this.info.areas_of_practice.length
                ? this.info.areas_of_practice.length - 1
                : null;
            case "image":
              let default_image =
                "https://dovemed-prod-k8s.s3.amazonaws.com/static/global/images/";
              default_image +=
                this.info.gender === "m" || "M"
                  ? "MALE DOCTOR2x.png"
                  : "WOMAN DOCTOR2x.png";
              return this.info.image
                ? `url('${this.info.image}')`
                : `url('${default_image}')`;
            default:
              return;
          }
          return;
      }
    }
  },

  props: {
    id: Number,
    info: Object,
    type: String,
    hideBtn: Boolean,
    isSelf: Boolean,
    affiliatedId: Number,
    page: Number,
    fetchDoc: Function
  },

  created() {
    this.activeIcon = this.info.is_verified ? svg1 : svg2;
  }
};
</script>

<style lang="scss" scoped>
.spinnerContainer2 {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba($color: #000000, $alpha: 0.2);
}

.spinner-border2 {
  width: 1rem !important;
  height: 1rem !important;
}
.card-container {
  border: 1px solid rgba(15, 116, 189, 0.3);
  border-radius: 6px;
  background-color: #ffffff;
  transition: 0.3s all linear;
  display: flex;
  flex-direction: row;
  margin-bottom: 16px;

  &:hover {
    border: 1px solid #a3cce6;
    background-color: #eff5fb;
    transform: scale(1.023);
  }
  .item-left {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 22px 16px;
    .user-img {
      height: 73px;
      width: 73px;
      cursor: pointer;
      border-radius: 50%;
      border: 1px solid #ccc;
      background-position: center !important;
      background-size: cover !important;
      background-repeat: no-repeat !important;
      .active-icon {
        height: 25px;
        width: 25px;
      }
    }
    .rating {
      margin-top: 6px;
      padding: 1px 5px;
      border-radius: 10px;
      background-color: #f5b255;
      color: #ffffff;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
    }
    .review {
      font-family: Lato;
      font-size: 8px;
      font-weight: bold;
      text-align: center;
      margin-top: 4px;
    }
  }
  .divider {
    width: 1px;
    background: rgba(15, 116, 189, 0.3);
    &:hover {
      background: #a3cce6;
    }
  }
  .item-right {
    overflow: auto;
    flex: 1;
    padding: 22px 16px;

    .promoted-label {
      border-radius: 7px;
      background-color: rgba(247, 181, 0, 0.25);
      color: #f98e46 !important;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      align-self: center;
      text-align: center;
      padding: 4px 10px;
      width: 89px;
      margin: 0;
      text-transform: uppercase;
      margin-bottom: 10px;
    }
    .provider-name {
      color: #333333;
      font-family: Lato;
      font-size: 20px;
      cursor: pointer;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .provider-title {
      color: rgba(51, 51, 51, 0.87) !important;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
    }
    .provider-desc {
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      color: #0f74bd;
    }
    .tags {
      display: flex;
      flex-direction: row;
      align-items: center;
      margin: 12px -5px 0 -5px;
      .crown {
        border-radius: 7px;
        background-color: rgba(247, 181, 0, 0.25);
        color: #f98e46;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin: 0px 5px;
        padding: 4px 10px;
      }
      .tag {
        border-radius: 7px;
        background-color: rgba(245, 178, 85, 0.25);
        color: #f98e46;
        font-family: Lato;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        margin: 0px 5px;
        padding: 4px 10px;
      }
    }
    .btn-container1 {
      @media (min-width: 768px) {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        margin-left: 15px;
      }
      .btn-primary1 {
        border-radius: 6px;
        background-color: #f5b255;
        color: #ffffff;
        font-family: Lato;
        font-size: 14px;
        line-height: 24px;
        font-weight: bold;
        text-align: center;
        margin-bottom: 10px;
        padding: 12px 24px;
        max-width: 161px;
        min-width: 132px;

        @media screen and (max-width: 900px) {
          padding: 7px 5px;
        }
      }
      .btn-secondary1 {
        border-radius: 17.5px;
        color: #f5b255;
        margin-top: 10px;
        background: #fff;
        font-family: Lato;
        font-size: 12px;
        padding: 5px 6px;
        font-weight: bold;
        text-align: center;
        max-width: 126px;
        min-width: 99px;
      }
    }
    .contact-number {
      color: #333333;
      font-family: Lato;
      font-size: 16px;
      font-weight: bold;
    }
    .address {
      color: rgba(51, 51, 51, 0.54);
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
    }
    .distance {
      color: #333333;
      font-family: Lato;
      font-size: 12px;
      font-weight: bold;
      margin-left: 15px;
    }
  }
}

@media screen and (max-width: 581px) {
  .card-container .item-right .provider-name {
    font-size: 16px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/provider/ProviderCard.vue